import { HoverCard, HoverCardContent, HoverCardTrigger } from '@e2n/ui';
import { getPausenartIndicator } from '@/domain/arbeitszeiten/components/EditSheet/content/Arbeitszeit/Pausen/getPausenartIndicator';
import { Pause } from '@/domain/arbeitszeiten/entities';
import { faCheck, faDash } from '@fortawesome/pro-regular-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import { Fragment, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';

export function PausenHoverCard({
  children,
  pausen,
}: {
  children: ReactNode;
  pausen: Pause[];
}) {
  const { t } = useTranslation();

  return (
    <HoverCard>
      <HoverCardTrigger>{children}</HoverCardTrigger>
      <HoverCardContent className="w-[300px] p-2 flex flex-col gap-2">
        <div className="flex justify-between items-center text-xs font-semibold text-neutrals-700">
          <span>{t('domain.arbeitszeiten.uebersicht.pausen.title')}</span>
          <span>{t('domain.arbeitszeiten.uebersicht.pausen.bezahlt')}</span>
        </div>
        {pausen?.map((pause) => (
          <Fragment key={pause.id}>
            <div key={pause.id} className="flex items-center justify-between ">
              <div className="flex items-center space-x-3">
                <FontAwesomeIcon
                  className="text-primary-blue-400"
                  icon={getPausenartIndicator(pause.art)}
                />
                <div className="flex flex-col">
                  <span className="font-semibold text-sm">
                    {pause.dauer} {t('general.date.minutes')}
                  </span>
                  {pause.beginn && (
                    <span className="text-xs font-normal text-neutrals-700">
                      {dayjs(pause.beginn).format('HH:mm') +
                        '–' +
                        dayjs(pause.ende).format('HH:mm') +
                        ` ${t('domain.arbeitszeiten.uebersicht.pausen.uhr')}`}
                    </span>
                  )}
                </div>
              </div>
              {pause.bezahlt ? (
                <FontAwesomeIcon className="text-neutrals-700" icon={faCheck} />
              ) : (
                <FontAwesomeIcon className="text-neutrals-700" icon={faDash} />
              )}
            </div>
            <div className="h-px w-full bg-neutrals-300 last:hidden" />
          </Fragment>
        ))}
      </HoverCardContent>
    </HoverCard>
  );
}
